import React from 'react';
import { Typography } from 'antd';

import { ModalTemplate } from './ModalTemplate';
import { useTrial } from '../useTrial';
import { CHURN_REASONS } from '../FreeTrial';
import useTrackTrialEvent from '../useTrackTrialEvent';

function ExtendTrialModal() {
  const { freeTrialState, updateFreeTrialState } = useTrial();
  const trackEvent = useTrackTrialEvent();

  const open = freeTrialState.user.churnFollowupModal === CHURN_REASONS.not_enough_time;

  const onCancel = () => {
    trackEvent('BannerClosed', { banner_name: 'Extend' });
    updateFreeTrialState({ state: { churnFollowupModal: null }, scope: 'user' });
    updateFreeTrialState({ state: { unconvertedFlowEnded: true }, scope: 'company' });
  };

  const onExtendTrial = () => {
    trackEvent('ExtendClicked', {});
    window.open('https://meetings-eu1.hubspot.com/james-condon', '_blank');
  };

  React.useEffect(() => {
    if (open) trackEvent('BannerShown', { banner_name: 'Extend' });
  }, [open]);

  return (
    <ModalTemplate
      open={open}
      title="Need more time?"
      cancelText="No thanks"
      cancelButtonProps={{ type: 'text' }}
      onCancel={onCancel}
      onOk={onExtendTrial}
      okText="Extend trial"
    >
      <Typography.Text>We are happy to help! Book a call with our team</Typography.Text>
    </ModalTemplate>
  );
}

export default ExtendTrialModal;
